import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
  const { isAuth, loading, user } = useContext(AuthContext);
  const hasPermission = permission => {
    const permissions = Array.isArray(permission) ? permission : [permission];
    return permissions.some(item => user?.permissions?.includes(item));
  };

  if (!isAuth && isPrivate) {
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
      </>
    );
  }

  if (isAuth && !isPrivate) {
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect to={{ pathname: "/tickets", state: { from: rest.location } }} />;
      </>
    );
  }

  if (
    isAuth &&
    isPrivate &&
    rest.permission &&
    user?.profile !== "admin" &&
    !hasPermission(rest.permission)
  ) {
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect to={{ pathname: "/tickets", state: { from: rest.location } }} />
      </>
    );
  }

  return (
    <>
      {loading && <BackdropLoading />}
      <RouterRoute {...rest} component={Component} />
    </>
  );
};

export default Route;
